<template>
    <div class="modalDialog is-active" role="dialog" aria-labelledby="modal-title" aria-describedby="modal-description" aria-hidden="true" @keyup.esc="closeModal">
        <div class="modal-contents" :style="{'max-width': maxWidth + 'px', 'height': height + 'px'}">
            <div>
                <a title="Close" class="close" @click="closeModal">X</a>
                <h3><slot id="modal-title" name="header">
                    Confirm
                </slot></h3>
                <hr />
            </div>
            <div>
                <slot id="modal-description" name="body">
                    Are you Sure?
                </slot>
                <hr />
            </div>
            <div class="right">
                <slot name="footer">
                    <span class="btn btn-default m-right-10" @click="closeModal">Cancel</span>
                    <span class="btn btn-primary" @click="confirmModal">OK</span>
                </slot>
            </div>
            <div class="clear"></div>
        </div>
    </div>
</template>
<script>
import {defineComponent} from 'vue';
export default defineComponent ({
    emits: ['close', 'modal-confirm'],
    props: {
        maxWidth: {
            type: String,
            required: false,
            default: '700'
        },
        height: {
            type: String,
            required: false,
            default: null
        },
    },

    data() {
        return {

        }
    },

    methods: {
        closeModal(event) {
            this.$emit('close');
        },
        confirmModal() {
            this.$emit('modal-confirm');
            this.closeModal();
        },
    },
    mounted () {
        this.$el.focus();
        let focusableEls = Array.prototype.slice.call(this.$el.querySelectorAll('input:not([hidden]), select:not([hidden]), textarea:not([hidden]), button:not([hidden]), a[href], area[href], [tabindex="0"]'))
        focusableEls[0].focus();
    }
});
</script>
